module.exports = {"type":"text","name":"singleNodeLabels","from":{"data":"singleNodeSymbols"},"encode":{"enter":{"text":{"field":"datum.label"},"align":{"value":"center"},"baseline":{"value":"bottom"},"fontSize":{"value":12},"fill":{"value":"black"}},"update":{"x":{"field":"x"},"y":{"field":"y","offset":-9}}}}


//////////////////
// WEBPACK FOOTER
// ./src/app/hsd-tree/sum-tree/vega-spec/marks/tree/single-nodes/label.json
// module id = 3eup
// module chunks = 0